// Reads the per-request CSP nonce that Rails emits via `csp_meta_tag`.
// Pass it to third-party SDKs (PayPal, etc.) that inject inline scripts
// at runtime so those scripts can satisfy our nonce-only script-src.
const cspNonce = () =>
  document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content')

export default cspNonce
